import { Item } from './components';
import S from './styles';

const Sidebar = S.Wrapper;

Sidebar.Item = Item;

export default Sidebar;
